import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { UpdateSectionStateCommand, UpdateSectionStateCommandPayload } from '../api';
import { SectionSuspendDataStateStore } from './section-suspend-data-state-store';

@injectable()
export class UpdateSectionStateCommandHandler implements CommandHandler<UpdateSectionStateCommand> {

  constructor(
    @inject(SectionSuspendDataStateStore)
    private readonly store: SectionSuspendDataStateStore) {
  }

  public async execute(payload: UpdateSectionStateCommandPayload) {
    await this.store.execute(createCommand<UpdateSectionStateCommand>('update-section-state', payload));
  }

}
